import React, { useState } from "react";
import { Alert } from "@mui/material";
import { useEditDhlVehicleMutation } from "../../api/vmsSlice";
import { Button, Input, toastMessage } from "../utils";
import { buttonClasses } from "../utils/theme";

const fields = [
	{ name: "trip_counter", label: "Trip Counter", },
	{ name: "vehicleNumber", label: "Current Vehicle Number", },
	{ name: "newVehicleNumber", label: "New Vehicle Number",  },
];

export default function EditDhlVehicle() {
	const [form, setForm] = useState({ trip_counter: "", vehicleNumber: "", newVehicleNumber: "" });
	const [feedback, setFeedback] = useState(null);
	const [editDhlVehicle, { isLoading }] = useEditDhlVehicleMutation();

	const handleSubmit = async (event) => {
		event.preventDefault();
		if (isLoading) return;
		setFeedback(null);
		const payload = Object.fromEntries(Object.entries(form).map(([key, value]) => [key, value.trim()]));
		if (Object.values(payload).some((value) => !value)) {
			setFeedback({ severity: "error", message: "Please fill in all three fields." });
			return;
		}
		try {
			const response = await editDhlVehicle(payload).unwrap();
			if (response?.error || response?.success === false || Number(response?.statusCode) >= 400) {
				const message = response.message || "Unable to update the vehicle. Please try again.";
				setFeedback({ severity: "error", message });
				toastMessage(false, message);
				return;
			}
			const message = response?.message || "Vehicle updated successfully.";
			setFeedback({ severity: "success", message });
			toastMessage(true, message);
		} catch (error) {
			const message = error?.data?.message || "Unable to update the vehicle. Please try again.";
			setFeedback({ severity: "error", message });
			toastMessage(false, message);
		}
	};

	return (
		<div className="contentpanel">
			<h1 className="title">Edit DHL Vehicle</h1>
			<hr className="bgg" />
			<form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.5rem", maxWidth: "480px", marginTop: "1.5rem" }}>
				{fields.map(({ name, label, placeholder }) => (
					<Input
						key={name}
						id={`edit-dhl-${name}`}
						name={name}
						label={label}
						placeholder={placeholder}
						value={form[name]}
						onChange={(event) => {
							setForm((previous) => ({ ...previous, [name]: event.target.value }));
							setFeedback(null);
						}}
						disabled={isLoading}
						required
					/>
				))}
				{feedback && <Alert severity={feedback.severity}>{feedback.message}</Alert>}
				<Button type="submit" text={isLoading ? "Updating..." : "Update Vehicle"} disabled={isLoading} style={buttonClasses.lynkitOrangeFill} />
			</form>
		</div>
	);
}
